// extracted by mini-css-extract-plugin
module.exports = {"h1":"heading_h1__1NQVK","h2":"heading_h2__kkLcC","h3":"heading_h3__nTE01","h4":"heading_h4__10_AK"};